import { track } from "lib/analytics";

const TRACKED = [
  { selector: ".pages-show .more a.button", category: "Read more" },
  { selector: "#small-sidebar .sections-sidebar-group a", category: "Mobile navigation - Section" },
  { selector: "#small-sidebar .services-sidebar-group a", category: "Mobile navigation - Services" },
  { selector: "#small-sidebar .information-sidebar-group a", category: "Mobile navigation - Information" },

  // Legacy pages#show layout
  { selector: "body.pages-show .section .lead-story a", category: "Content summary - Lead story (legacy)" },
  { selector: "body.pages-show .section .a-format a", category: "Content summary - A format (legacy)" },
  { selector: "body.pages-show .section .b-format a", category: "Content summary - B format (legacy)" },
  { selector: "body.pages-show .section .c-format a", category: "Content summary - C format (legacy)" },
  { selector: "body.pages-show .section .d-format a", category: "Content summary - D format (legacy)" },
  { selector: "body.pages-show .section #editors-picks a", category: "Content summary - Editors pick (legacy)" },
  { selector: "body.pages-show .section #podcasts a", category: "Podcast (legacy)" },

  // Arts pages#show layout
  { selector: "body.pages-show .arts .blocks a", category: "Content summary - Block (arts)" },
  { selector: "body.pages-show .arts #editors-picks a", category: "Content summary - Editors pick (arts)" },
  { selector: "body.pages-show .arts .b-format a", category: "Content summary - B format (arts)" },
  { selector: "body.pages-show .arts .c-format a", category: "Content summary - C format (arts)" },
];

const SCHEME_PATTERN = /^((http|https):)/;

const trackSelector = ({ selector, category }) => {
  document.querySelectorAll(selector).forEach((element) => {
    element.addEventListener("click", () => track(category, "Click"));
  });
};

const trackAllOutboundLinks = () => {
  const currentHostname = window.location.hostname;

  // Track all outbound links by detecting which links are absolute and
  // do not contain the current hostname.
  document.querySelectorAll("a").forEach((element) => {
    const url = element.getAttribute("href");

    // If the url doesn't contain a scheme just bail out
    // immediately as it's likely:
    //  - blank
    //  - containing only an anchor (eg "#foo")
    //  - relative
    if (!SCHEME_PATTERN.test(url)) { return; }

    const location = new URL(url);

    // If the link hostname matches the current location hostname bail out
    if (location.hostname === currentHostname) { return; }

    element.addEventListener("click", () => track("Outbound link", "Click", url, 1, false));
  });
};

// A simple mechanism for setting up tracking for links rendered by ERB.
//
// Add a selector to the list and links which match it will have an event
// tracked in Google Analytics for it.
//
// Should not be used for links rendered by JS!
export default () => {
  // If the browser doesn't support querySelectorAll or URL just don't bother
  //
  // This will exclude some versions of Internet Explorer.
  if (!document.querySelectorAll || !URL) { return; }

  TRACKED.forEach(trackSelector);
  trackAllOutboundLinks();
};
